<script setup lang="ts">
import SectionHeading from '@/components/SectionHeading.vue';
import DisclosureDeals from '@/features/disclosure/DisclosureDeals.vue';
import DisclosureInfo from '@/features/disclosure/DisclosureInfo.vue';
import DisclosureReports from '@/features/disclosure/DisclosureReports.vue';
</script>

<template>
  <section class="page-hero">
    <div class="container-narrow">
      <SectionHeading
        as="h1"
        eyebrow="Раскрытие информации"
        title="Раскрытие информации о лизинговой деятельности"
        lead="Сведения раскрываются в объёме, предусмотренном Инструкцией об объёме и порядке раскрытия информации о лизинговой деятельности и финансовом состоянии лизинговых организаций, утверждённой постановлением Правления Национального банка Республики Беларусь от 01.08.2014 № 495."
      />
    </div>
  </section>

  <DisclosureInfo />
  <DisclosureDeals />
  <DisclosureReports />
</template>
